<script setup lang="ts">
const { width = 300, height = 140 } = defineProps<{
  width?: number
  height?: number
}>()
</script>

<template>
  <svg class="skeleton" xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${width} ${height}`">
    <defs>
      <linearGradient id="signature-shimmer-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="rgba(255, 255, 255, 0)" />
        <stop offset="50%" stop-color="rgba(255, 255, 255, 0.3)" />
        <stop offset="100%" stop-color="rgba(255, 255, 255, 0)" />
      </linearGradient>
    </defs>
    <circle :cx="width * 0.15" :cy="height * 0.32" :r="Math.min(width, height) * 0.18" class="bone" />
    <rect
      :x="width * 0.3"
      :y="height * 0.14"
      :width="width * 0.63"
      :height="height * 0.11"
      :rx="height * 0.054"
      class="bone"
    />
    <rect
      :x="width * 0.3"
      :y="height * 0.3"
      :width="width * 0.33"
      :height="height * 0.11"
      :rx="height * 0.054"
      class="bone"
    />
    <rect
      :x="width * 0.3"
      :y="height * 0.46"
      :width="width * 0.43"
      :height="height * 0.11"
      :rx="height * 0.054"
      class="bone"
    />
    <rect
      :x="width * 0.07"
      :y="height * 0.75"
      :width="width * 0.87"
      :height="height * 0.11"
      :rx="height * 0.054"
      class="bone"
    />
    <rect :x="-width" y="0" :width="width" :height="height" class="shimmer">
      <animate attributeName="x" :from="-width" :to="width" dur="1.5s" repeatCount="indefinite" />
    </rect>
  </svg>
</template>

<style lang="scss" scoped>
.skeleton {
  display: block;
  cursor: wait;
  max-width: 100%;
  max-height: 100%;

  .bone {
    fill: rgba(0, 0, 0, 0.12);
  }

  .shimmer {
    fill: url(#signature-shimmer-gradient);
  }
}
</style>
